export const headersUsers = [
  '#',
  'שם מלא',
  'מייל',
  'מספר סוכן',
  'ת.ז.',
  'מספר בשיקלולית',
  'כתובת',
  'טלפון',
  'קבלת התראות',
  'תאריך רישום',
  'תחום עיסוק',
  'פעיל',
  'תאריך העברה אחרונה',
];

export const headersBituahLeumi = [
  '#',
  'סוכן',
  'שם פרטי',
  'שם משפחה',
  'ת.ז.',
  'סכום',
  'תאריך תשלום',
  'סטאטוס'
];

export const getHeadersCompleteDetails = (year) => {
  return {
    employeeID: 'מספר עובד',
    idNumber: 'תעודת זהות',
    fullName: 'שם מלא',
    bankCode: 'קוד בנק',
    branchNumber: 'מספר סניף',
    accountNumber: 'סכום לתשלום',
    amount: 'סכום לתשלום',
    agentID: 'מספר סוכן',
    phone: 'טלפון',
    email: 'אימייל',
    year: year ? `טופס עבור ${year} קיים` : 'טופס קיים',
    comments: 'הערות',
  }
}

export const headersReceipts = [
  '#',
  'מספר קבלה',
  'מספר סוכן',
  'סוכן',
  'מזהה לקוח',
  'לקוח',
  'תאריך יצירה',
  'סכום',
  'חשבוניות',
  'תאריך הנפקת חשבונית',
];

export const headersRegistrationData = [
  '#',
  'שם מלא',
  'טלפון',
  'מייל',
  'איך שמעת עלינו',
  'תחום עיסוק',
  'השלב האחרון שהושלם',
  'זמן בתהליך',
  'עדכון אחרון',
  'מזהה סוכן',
  'מספר בשיקלולית',
];

export const headersPartners = [
  '#',
  'שם מלא',
  'ת.ז.',
  'טלפון',
  'אימייל',
  'תאריך רישום',
  'השלב האחרון שהושלם',
  'שותף',
];

export const headersInvitedUsersExcelFile = {
  itemNumber: '#',
  invitedFriendName: 'שם המוזמן',
  invitedFriendPhone: 'טלפון המוזמן',
  invitingUserName: 'שם המזמין',
  invitingUserAgentID: 'מספר סוכן המזמין',
  lastCompletedStep: 'השלב האחרון שהושלם',
  agentID: 'מזהה סוכן',
  registrationDate: 'תאריך רישום',
  invoicesCount: 'מספר חשבוניות',
  invoicesTotalAmount: 'סכום כולל'
}

export const headersCustomers = [
  '#',
  "מספר לקוח",
  "שם לקוח",
  "שם איש קשר",
  "ח.פ.",
  "כתובת",
  "טלפון",
  "מייל",
  "סך מכירות השנה",
  "לאפשר חשבונית עסקה",
];

export const headersAgentsIncomes = [
  '#',
  'שם מלא',
  'מספר סוכן',
  'מייל',
  'טלפון',
  'סך מכירות',
  'תאריך חשבונית אחרונה'
];

export const headersProjects = [
  'First Name',
  'Last Name',
  'Email',
  'Phone',
  'Address',
  'City',
  'Country',
  'Company',
  'Custom',
];

export const headersInvoices = [
  '#',
  'מספר',
  'מספר סוכן',
  'סוכן',
  'מזהה לקוח',
  'לקוח',
  'תאריך',
  'סכום',
  'מע”מ',
  'סטאטוס',
  'התראות',
  'קבלות',
];

export const headersUnpaidAgents = [
  '#',
  'תביעה ייצוגית',
  'שם פרטי',
  'שם משפחה',
  'מספר סוכן',
  'מספר בשקלולית',
  'טלפון',
  'טופס 101',
  'תיאום מס',
];

export const headersUsersActions = [
  '#',
  'שם משתמש',
  'תאריך הפעולה',
  'תיאור הפעולה',
  'עמוד',
  'נושא',
  'מטען',
  'תוצאת הפעולה',
];

export const headersUsersClientActions = [
  '#',
  'שם משתמש',
  'תאריך הפעולה',
  'סוג פעולה',
  'עמוד',
  'נושא',
  'מטען',
  'תוצאת הפעולה',
];

export const headersPaypalRequests = [
  '#',
  'מזהה סוכן',
  'סוכן שם',
  'לקוח שם',
  'לקוח מייל',
  'סכום',
  'תאור',
  'זמן יצירת הבקשה',
  'עבור חשבונית',
  'מזהה תשלום',
  'סטטוס',
];

export const headersTransfers = [
  '#',
  'מזהה סוכן',
  'סוכן שם',
  'תאריך',
  'משכורת',
  'מספר קבלה',
  'לקוח',
  'תאריך קבלה',
  'סוג תשלום',
  'סכום',
];

export const headersNotifications = [
  '#',
  'זמן משלוח',
  'נושא',
  'סוג שליחה',
  'מקור',
  'סטטוס',
  'הערות',
  'מזהה סוכן',
  'סוכן שם',
  'מזהה לקוח',
  'לקוח',
];

export const headersLawAgents = [
  '#',
  'מספר סוכן',
  'שם מלא',
  'ת.ז.',
  'בשקלולית',
  'אימייל',
  'סכום לתשלום',
  'שולם עד כה',
  'נותר לתשלום',
];

export const headersLawTransactions = [
  '#',
  'מספר סוכן',
  'שם מלא',
  'תאריך',
  'סוג ההטבה',
  'קוד מימוש',
  'סכום',
];

export const headersLawUploadResult = [
  '#',
  "מס' סוכן",
  "שם מלא",
  "ת.ז",
  "מס' עובד",
  "מייל",
  "ת. רישום",
  "סוג",
  "קוד מימוש",
  "ההטבה",
  "סכום",
  "שנוצל"
];